import { LOCAL_STORAGE, LocalStorage } from '@blink/components/src/utils';
import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Store } from '@/shared/store';

interface AuthContextType {
    isLoggedIn: boolean;
    login: (token: string) => void;
    logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { name } = useSelector((state: Store) => ({
        name: state.organization.info.name,
    }));

    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(() => {
        return !!LocalStorage.getItem(LOCAL_STORAGE.LOGGED_IN) || !!name;
    });

    useEffect(() => {
        setIsLoggedIn(!!name || !!LocalStorage.getItem(LOCAL_STORAGE.LOGGED_IN));
    }, [name]);

    const login = () => {
        setIsLoggedIn(true);
    };

    const logout = () => {
        setIsLoggedIn(false);
    };

    return (
        <AuthContext.Provider value={{ isLoggedIn, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
